(() => {
  const webhookUrl = 'https://n8n.method.cl/webhook/onlyshop-webchat';
  const launcher = document.getElementById('onlyshop-webchat-launcher');
  const panel = document.getElementById('onlyshop-webchat-panel');
  const closeButton = document.getElementById('onlyshop-webchat-close');
  const messages = document.getElementById('onlyshop-webchat-messages');
  const form = document.getElementById('onlyshop-webchat-form');
  const input = document.getElementById('onlyshop-webchat-input');
  const sendButton = document.getElementById('onlyshop-webchat-send');

  if (!launcher || !panel || !messages || !form || !input || !sendButton) return;

  const sessionId = () => {
    const key = 'onlyshop_webchat_session';
    try {
      let value = localStorage.getItem(key);
      if (!value) {
        value = window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : `visitor-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        localStorage.setItem(key, value);
      }
      return value;
    } catch {
      return `visitor-${Date.now()}`;
    }
  };

  const addMessage = (text, type, pending = false) => {
    const message = document.createElement('div');
    message.className = `onlyshop-webchat-message ${type}${pending ? ' pending' : ''}`;
    message.textContent = text;
    messages.appendChild(message);
    messages.scrollTop = messages.scrollHeight;
    return message;
  };

  const setOpen = (open) => {
    panel.hidden = !open;
    launcher.setAttribute('aria-expanded', String(open));
    if (open) setTimeout(() => input.focus(), 0);
  };

  launcher.addEventListener('click', () => setOpen(panel.hidden));
  closeButton.addEventListener('click', () => setOpen(false));
  document.querySelectorAll('[data-onlyshop-prompt]').forEach((button) => {
    button.addEventListener('click', () => {
      input.value = button.dataset.onlyshopPrompt;
      form.requestSubmit();
    });
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      form.requestSubmit();
    }
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const text = input.value.trim();
    if (!text || sendButton.disabled) return;

    addMessage(text, 'user');
    input.value = '';
    sendButton.disabled = true;
    const pending = addMessage('Escribiendo…', 'bot', true);

    try {
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, sessionId: sessionId() }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      pending.remove();
      addMessage(String(data.reply || 'No pude generar una respuesta. Intenta nuevamente.'), 'bot');
    } catch (error) {
      console.error('OnlyShop webchat:', error);
      pending.remove();
      addMessage('No pude conectarme en este momento. Intenta nuevamente en unos segundos.', 'bot');
    } finally {
      sendButton.disabled = false;
      input.focus();
    }
  });
})();
